import { useToken } from '@abyss/web/hooks/useToken';
import React, { useContext } from 'react';

import { PortalContext } from '../context/PortalContext';
import { ProviderTypes } from './Constants';
import { IconBrandAndSymbol } from './IconBrandAndSymbol';
import { IconName } from './IconBrandAndSymbol/types';

export type Props = {
  imgRef: React.RefObject<HTMLImageElement>;
  providerType?: string;
  imgSrc?: string;
  bhIcon?: string;
  sizeToken?: string;
  css?: Object;
  expandedProviderListView?: boolean;
  isGroupedLocationDrawer?: boolean;
  notXlScreen?: boolean;
  TabletScreen?: boolean;
  enableMapViewHideOption?: boolean;
};

export const ImageComponent = ({
  imgRef,
  providerType,
  imgSrc,
  bhIcon,
  sizeToken,
  expandedProviderListView,
  isGroupedLocationDrawer,
  notXlScreen,
  TabletScreen,
  enableMapViewHideOption = false,
  ...otherProps
}: Props) => {
  let dataTestId: string;
  const { portalData } = useContext(PortalContext);
  const portalConfigCheck = portalData?.portalConfig?.theme === 'optum';
  const networkIcon = portalConfigCheck ? 'network_circle' : 'network';
  const getSizes = useToken('sizes');
  const groupedPinIconSize = notXlScreen ? 72 : 128;
  const otherIconSize = expandedProviderListView
    ? TabletScreen
      ? 112
      : 128
    : enableMapViewHideOption
    ? 80
    : getSizes(sizeToken);
  const iconSize = isGroupedLocationDrawer ? groupedPinIconSize : otherIconSize;
  if (
    (imgSrc && (imgSrc.includes('default') || imgSrc.includes('/bio-pics/'))) ||
    imgRef?.current?.src?.includes('error')
  ) {
    dataTestId = 'default-image';
    if (bhIcon) {
      if (
        providerType?.toLowerCase() === ProviderTypes.ORGANIZATION.toLowerCase()
      ) {
        return (
          <IconBrandAndSymbol
            data-testid={dataTestId}
            icon={IconName.clinic}
            size={iconSize}
            {...otherProps}
          />
        );
      } else if (
        providerType?.toLowerCase() ===
          ProviderTypes.PROVIDER_GROUPS.toLowerCase() ||
        providerType?.toLowerCase() ===
          ProviderTypes.MEDICALGROUP.toLowerCase() ||
        providerType?.toLowerCase() === ProviderTypes.GROUP.toLowerCase() ||
        providerType?.toLowerCase() ===
          ProviderTypes.MEDICAL_GROUP.toLowerCase()
      ) {
        return (
          <IconBrandAndSymbol
            data-testid={dataTestId}
            icon={networkIcon as IconName}
            size={iconSize}
            {...otherProps}
          />
        );
      } else {
        return (
          <IconBrandAndSymbol
            data-testid={dataTestId}
            icon={bhIcon as IconName}
            size={iconSize}
            {...otherProps}
          />
        );
      }
    }
    return (
      <IconBrandAndSymbol
        data-testid={dataTestId}
        icon={providerType as IconName}
        size={iconSize}
        {...otherProps}
      />
    );
  } else {
    dataTestId = 'provider-image';
  }

  return (
    <img
      alt=""
      data-testid={dataTestId}
      ref={imgRef}
      src={imgSrc}
      style={{
        width: '100%',
      }}
    />
  );
};
